import { render, staticRenderFns } from "./PostalAddressView.vue?vue&type=template&id=6dfefc2b&scoped=true&"
import script from "./PostalAddressView.vue?vue&type=script&lang=js&"
export * from "./PostalAddressView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfefc2b",
  null
  
)

export default component.exports